import isValidSelectedOffer from './isValidSelectedOffer';

export default isValidSelectedOffer;
